import React from 'react';

const FormResponseMessage = (props) => {
    return (
        <div className="form-group">
            <div className={props.LeftWrapper}></div>
            <div className={props.CenterWrapper}>
                {
                    (typeof props.Message) === 'object'?
                        <div className={props.MessageStyle}>
                            {props.Message}
                        </div>
                        :
                        <div className={props.MessageStyle} dangerouslySetInnerHTML={{__html: props.Message}}>
                        </div>
                }
            </div>
            <div className={props.RightWrapper}></div>
        </div>
    )
};

export default FormResponseMessage;